///home/clement/compta-app/client/src/components/Banque/RapprochementBancaire.js

import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Typography,
  Box,
  Button,
  CircularProgress,
  Snackbar,
  Alert
} from '@mui/material';
import { fetchReleveBancaire, fetchTransactions } from '../../api/rapprochementApi';

const RapprochementBancaire = () => {
  const [releveBancaire, setReleveBancaire] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedTransactions, setSelectedTransactions] = useState({});
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [message, setMessage] = useState('');

  // Charger les relevés bancaires et les transactions
  useEffect(() => {
    const loadData = async () => {
      try {
        const [releve, trans] = await Promise.all([
          fetchReleveBancaire(),
          fetchTransactions(),
        ]);
        setReleveBancaire(releve);
        setTransactions(trans);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  // Gestion des cases à cocher pour le rapprochement
  const handleCheckboxChange = (id, isReleve = false) => {
    setSelectedTransactions(prev => ({
      ...prev,
      [isReleve ? `releve_${id}` : `trans_${id}`]: !prev[isReleve ? `releve_${id}` : `trans_${id}`],
    }));
  };

  // Valider le rapprochement
  const handleValider = () => {
    // Logique pour enregistrer les rapprochements (à adapter selon ton API)
    setMessage('Rapprochement validé avec succès !');
    setOpenSnackbar(true);
  };

  if (loading) return <CircularProgress />;
  if (error) return <Alert severity="error">{error}</Alert>;

  return (
    <Box className="rapprochement-bancaire">
      <Typography variant="h4" gutterBottom>
        Rapprochement bancaire
      </Typography>

      <Box display="flex" justifyContent="space-between" marginBottom={2}>
        <TableContainer component={Paper} style={{ width: '48%' }}>
          <Typography variant="h6">Relevé bancaire</Typography>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Libellé</TableCell>
                <TableCell>Montant</TableCell>
                <TableCell>Rapproché</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {releveBancaire.map((item) => (
                <TableRow key={`releve_${item.id}`}>
                  <TableCell>{item.date}</TableCell>
                  <TableCell>{item.libelle}</TableCell>
                  <TableCell>{item.montant} €</TableCell>
                  <TableCell>
                    <Checkbox
                      checked={!!selectedTransactions[`releve_${item.id}`]}
                      onChange={() => handleCheckboxChange(item.id, true)}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TableContainer component={Paper} style={{ width: '48%' }}>
          <Typography variant="h6">Transactions enregistrées</Typography>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Libellé</TableCell>
                <TableCell>Montant</TableCell>
                <TableCell>Rapproché</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {transactions.map((item) => (
                <TableRow key={`trans_${item.id}`}>
                  <TableCell>{item.date}</TableCell>
                  <TableCell>{item.libelle}</TableCell>
                  <TableCell>{item.montant} €</TableCell>
                  <TableCell>
                    <Checkbox
                      checked={!!selectedTransactions[`trans_${item.id}`]}
                      onChange={() => handleCheckboxChange(item.id)}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Button
        variant="contained"
        color="primary"
        onClick={handleValider}
      >
        Valider le rapprochement
      </Button>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert severity="success">{message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default RapprochementBancaire;

